import { render, staticRenderFns } from "./DeliveryTypeAddEditModal.vue?vue&type=template&id=10a1e79c&"
import script from "./DeliveryTypeAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryTypeAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports